module.exports = __webpack_public_path__ + "static/media/cinnemon2.9c5e65ab.jpeg";